import { render, staticRenderFns } from "./DeparturesPageGuarapuava.vue?vue&type=template&id=567076ba&"
import script from "./DeparturesPageGuarapuava.vue?vue&type=script&lang=js&"
export * from "./DeparturesPageGuarapuava.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesPageGuarapuava.vue?vue&type=style&index=0&id=567076ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports